module.exports = __webpack_public_path__ + "static/evaporator-6e3859ed66fcf52a14912e2012585b3e.png";